
import {Component, OnInit, Input} from 'ng-metadata/core';

@Component({
    "inputs":['showmoredeliveryoptions'],
    "selector": 'prm-physical-delivery-options',
    templateUrl: 'components/search/fullView/ngrs/physicalDeliveryOptions/physicalDeliveryOptions.html',
})

export class PrmPhysicalDeliveryOptions{

    @Input() showmoredeliveryoptions: Object;

    constructor (){       
    }

    ngOnInit(){
    }    

    public getPhysicalResult(){
        this.showmoredeliveryoptions.showMoreDeliveryOptions=!this.showmoredeliveryoptions.showMoreDeliveryOptions;
    }    

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/physicalDeliveryOptions/physicalDeliveryOptions.directive.ts